import { mapActions } from "vuex";
import * as types from "@/store/types";
import { AuthService } from "@/services";

export default {
  name: "email-auth",
  components: {},
  props: [],
  data() {
    return {
      otpCode: "",
      countdownTimer: "",
      isCounterExpired: false,
      repeatLoading: false,
      clockInterval: "",
      rules: {
        required: value =>
          !!value || this.$t("authPage.emailAuthPage.otpCode.validation")
        // min: v => v.length >= 8 || "Min 8 characters",
        // emailMatch: () => `The email and password you entered don't match`
      }
    };
  },
  computed: {
    otpToken() {
      return localStorage.getItem("otpToken");
    },
    emailOrMobile() {
      return localStorage.getItem("emailOrMobile");
    },
    ttl() {
      return localStorage.getItem("ttl");
    }
  },
  mounted() {
    this.countdown(this.ttl);
  },
  methods: {
    ...mapActions({
      checkIsAuth: types.auth.actions.ACTION_CHECK_IS_AUTH
    }),
    onSubmit() {
      this.loading = true;
      this.verifyUserOtp();
    },
    countdown(distance) {
      distance = distance / 1000;
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    },
    verifyUserOtp() {
      let otpToken = localStorage.getItem("emailOtpToken");
      AuthService.verifyUserEmailOtp(this.otpCode, otpToken)
        .then(response => {
          localStorage.setItem("accessToken", response.data.data.token);
          this.$cookies.set("accessToken", response.data.data.token);

          localStorage.setItem(
            "refreshToken",
            response.data.data.refresh_token
          );
          this.$cookies.set("refreshToken", response.data.data.refresh_token);

          localStorage.removeItem("emailOtpToken");
          localStorage.setItem("isAuth", "true");
          this.checkIsAuth();
          this.$router.push(`/dashboard`);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtpCode() {
      this.repeatLoading = true;
      let otpToken = localStorage.getItem("emailOtpToken");
      AuthService.resendLoginEmailOtp(otpToken)
        .then(response => {
          localStorage.setItem("emailOtpToken", response.data.data.otp_token);
          this.countdown(response.data.data.ttl);
          this.isCounterExpired = !this.isCounterExpired;
          this.$toast.success(response.data.message);
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
        })
        .finally(() => {
          this.repeatLoading = false;
        });
    }
  }
};
